import { PortalDialogProps } from "@app/services/modal.service";
import Modal from "../modal/modal.component";
import Input from "../input";
import { Form, Formik } from "formik";
import { FormControl } from "../form-control";
import Button from "../button";
import { createReferredCodeValidationSchema } from "@app/validations/referred.validation";

function InputReferredModal({ portalDialogRef }: PortalDialogProps) {
  const onSubmit = (values: { referredCode: string }) => {
    portalDialogRef.close({ referredCode: values.referredCode });
  };

  return (
    <Modal onCancel={portalDialogRef.close}>
      <div className="p-6 w-[380px] flex flex-col items-center">
        <div className="text-[#171A20] font-[SVN-Gilroy] font-bold text-2xl">
          Người giới thiệu
        </div>
        <div className="text-[#424E62] font-[SVN-Gilroy] font-medium mt-2 text-center">
          Để được nhiều kas hơn khi nâng cấp VIP hoặc nạp Kas.
        </div>
        <Formik
          initialValues={{
            referredCode: "",
          }}
          onSubmit={onSubmit}
          validationSchema={createReferredCodeValidationSchema}
          validateOnBlur
          validateOnChange
        >
          <Form>
            <FormControl name="referredCode">
              <Input
                width={332}
                className="mt-5"
                placeholder="Nhập mã người giới thiệu"
                inputClassName="font-[SVN-Gilroy] font-medium rounded-xl !text-[#272C36] tracking-[0.024px]"
                errorClassName="font-[SVN-Gilroy] tracking-[0.024px]"
              />
            </FormControl>
            <Button
              type="submit"
              containerClassName="mt-5 mx-auto"
              label="Xác nhận"
              labelClassName="font-[SVN-Gilroy] text-white font-bold text-base"
              width=""
              size="l"
              theme="none"
              className="text-lg font-bold px-11 !rounded-3xl bg-[linear-gradient(180deg,#5A82D7_-18.89%,#4667CA_141.11%)]"
            />
          </Form>
        </Formik>
      </div>
    </Modal>
  );
}

export default InputReferredModal;
